



































import { Component, Vue, Prop, Emit, Model } from 'vue-property-decorator';

@Component
export default class Dropdown extends Vue {
    @Prop({ default: false })
    loading!: boolean;
    @Prop({ default: false })
    border!: boolean;
    @Prop({ default: 'normal' })
    size!: string;
    @Prop()
    options!: any[];

    @Model('change', { type: String | Number })
    selectedModel!: string | number;

    get dropdownClass() {
        return [
            this.border ? 'border' : '',
            `size-${this.size}`,
        ]
    }

    get text() {
        if (this.selectedModel) {
            const item = _.find(this.options, { value: this.selectedModel });
            return item && item.label ? item.label : this.selectedModel;
        }
        return '';
    }

    @Emit('change')
    handleSelect(item) {
        return item.value;
    }
}
